import { useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import wayneRetainingWall from "@/assets/before-after-retaining-wall-installation-wayne-nj-t.webp";
import cedarGroveDriveway from "@/assets/before-after-paver-driveway-installation-cedar-grove-nj-t.webp";
import veronaPaverWalkway from "@/assets/before-after-paver-walkway-verona-nj-t.webp";
import cliftonPaverPatio from "@/assets/before-after-paver-patio-clifton-nj-t.webp";
import caldwellWalkwaySteps from "@/assets/before-after-front-walkway-steps-replacement-caldwell-nj-t.webp";
import nutleyRetainingWall from "@/assets/before-after-retaining-wall-nutley-nj-t.webp";
import northCaldwellBrickSteps from "@/assets/before-after-brick-steps-north-caldwell-nj-t.webp";
import paramusPatioPavers from "@/assets/patio-paver-installation-paramus-bergen-county-nj.webp";
import concreteSidewalkTotowa from "@/assets/concrete-sidewalk-totowa-nj.webp";
import patioNutley from "@/assets/patio-paver-installation-nutley-nj.webp";
import patioParamus from "@/assets/patio-paver-installation-paramus-nj.webp";
import patioReplacementParamus from "@/assets/patio-paver-replacement-paramus-nj.webp";
import patioMontclair from "@/assets/patio-paver-installation-montclair-nj.webp";
import paverPatioWayne from "@/assets/paver-patio-installation-wayne-nj.webp";
import paverPatioParamus from "@/assets/paver-patio-paramus-nj.webp";
import masonyStepsClifton from "@/assets/masonry-steps-installation-clifton-nj.webp";
import paverPatioHaskell from "@/assets/paver-patio-installation-haskell-nj.webp";
import outdoorKitchenKinnelon from "@/assets/outdoor-kitchen-paver-patio-kinnelon-nj.webp";
import paverPatioBloomingdale from "@/assets/paver-patio-installation-bloomingdale-nj.webp";
import paverPatioStoneWallPompton from "@/assets/paver-patio-stone-wall-pompton-lakes-nj.webp";
import retainingWallPompton from "@/assets/retaining-wall-pompton-lakes-nj.webp";
import stoneMasonryStepsFairLawn from "@/assets/stone-masonry-steps-fair-lawn-nj.webp";
import patioClifton from "@/assets/patio-paver-installation-clifton-nj.webp";
import patioParamus4 from "@/assets/patio-paver-installation-paramus-nj-4.webp";
import masonyStepsWoodlandPark from "@/assets/masonry-steps-installation-woodland-park-nj.webp";
import paverDrivewayTotowa from "@/assets/paver-driveway-retaining-wall-totowa-nj.webp";
import patioLittleFalls from "@/assets/patio-installation-little-falls-nj.webp";
import retainingWallMillburn from "@/assets/retaining-wall-installation-millburn-nj.webp";
import retainingWallShortHills from "@/assets/retaining-wall-replacement-short-hills-nj.webp";
import retainingWallWestOrange from "@/assets/retaining-wall-replacement-west-orange-nj.webp";
import paverPatioMontclairNew from "@/assets/paver-patio-installation-montclair-nj.webp";
import paverPatioPathwayHackensack from "@/assets/paver-patio-and-pathway-hackensack-nj.webp";
import paverPatioHackensack from "@/assets/paver-patio-installation-hackensack-nj.webp";
import retainingWallHawthorne from "@/assets/retaining-wall-installation-hawthorne-nj.webp";
import paverPatioEssexFells from "@/assets/paver-patio-installation-essex-fells-nj.webp";
import masonryStepsMidlandPark from "@/assets/masonry-steps-midland-park-nj.webp";
import retainingWallTotowa2 from "@/assets/retaining-wall-installation-totowa-nj-2.webp";
import retainingWallPaterson from "@/assets/retaining-wall-replacement-paterson-nj.webp";
import retainingWallWayneNew from "@/assets/retaining-wall-installation-wayne-nj.webp";
import retainingWallWayneBA from "@/assets/before-after-retaining-wall-installation-wayne-nj.webp";

const projects = [
  {
    image: wayneRetainingWall,
    title: "Retaining Wall Installation",
    location: "Wayne, NJ",
    alt: "Before and after retaining wall installation in Wayne, New Jersey, showing a sloped backyard stabilized with a professionally built masonry retaining wall.",
  },
  {
    image: cedarGroveDriveway,
    title: "Driveway & Walkway Replacement",
    location: "Cedar Grove, NJ",
    alt: "Before and after driveway and walkway replacement in Cedar Grove, New Jersey, featuring a custom paver driveway and curved paver walkway installation.",
  },
  {
    image: veronaPaverWalkway,
    title: "Paver Patio & Walkway",
    location: "Verona, NJ",
    alt: "Before and after paver patio and walkway replacement in Verona, New Jersey, showing a professionally installed paver surface replacing a worn and uneven backyard path.",
  },
  {
    image: cliftonPaverPatio,
    title: "Paver Patio Extension",
    location: "Clifton, NJ",
    alt: "Before and after paver patio replacement and extension in Clifton, New Jersey, showing an outdated patio upgraded to a larger custom paver patio.",
  },
  {
    image: caldwellWalkwaySteps,
    title: "Front Walkway & Steps",
    location: "Caldwell, NJ",
    alt: "Before and after front walkway and step replacement in Caldwell, New Jersey, featuring a custom paver walkway and redesigned entry steps for a residential home.",
  },
  {
    image: nutleyRetainingWall,
    title: "Retaining Wall Replacement",
    location: "Nutley, NJ",
    alt: "Before and after retaining wall replacement in Nutley, New Jersey, showing an old failing wall replaced with a new masonry retaining wall for improved stability and appearance.",
  },
  {
    image: northCaldwellBrickSteps,
    title: "Brick Steps Replacement",
    location: "North Caldwell, NJ",
    alt: "Before and after brick steps replacement in North Caldwell, New Jersey, showing deteriorated masonry steps rebuilt with new brickwork and stone caps.",
  },
  {
    image: paramusPatioPavers,
    title: "Patio Paver Installation",
    location: "Paramus, NJ",
    alt: "New patio paver installation around a backyard pool at a residence in Paramus, Bergen County, NJ by Masonry Pro Construction",
  },
  {
    image: concreteSidewalkTotowa,
    title: "Concrete Sidewalk Installation",
    location: "Totowa, NJ",
    alt: "Dirt path with wooden forms 'before' and finished concrete sidewalk 'after' installation in Totowa, Passaic County, NJ.",
  },
  {
    image: patioNutley,
    title: "Patio Paver Installation",
    location: "Nutley, NJ",
    alt: "Before and after a patio paver installation in Nutley, Essex County, NJ, by Masonry Pro Construction.",
  },
  {
    image: patioParamus,
    title: "Patio Paver Installation",
    location: "Paramus, NJ",
    alt: "New patio paver installation and outdoor kitchen area next to a home in Paramus, Bergen County, NJ.",
  },
  {
    image: patioReplacementParamus,
    title: "Patio Paver Replacement",
    location: "Paramus, NJ",
    alt: "Recently replaced patio paver in the backyard of a house in Paramus, Bergen County, NJ by Masonry Pro Construction.",
  },
  {
    image: patioMontclair,
    title: "Patio Paver Installation",
    location: "Montclair, NJ",
    alt: "Patio paver installation before and after around a swimming pool in Montclair, Essex County, NJ by Masonry Pro Construction.",
  },
  {
    image: paverPatioWayne,
    title: "Patio Paver Installation",
    location: "Wayne, NJ",
    alt: "New paver patio installation next to a house with white siding in Wayne, Passaic County, NJ, by Masonry Pro Construction.",
  },
  {
    image: paverPatioParamus,
    title: "Patio Paver Installation",
    location: "Paramus, NJ",
    alt: "Newly installed paver patio with a built-in outdoor kitchen and steps in Paramus, Bergen County, NJ by Masonry Pro Construction.",
  },
  {
    image: masonyStepsClifton,
    title: "Masonry Steps Installation",
    location: "Clifton, NJ",
    alt: "Masonry steps installation before and after for a residential home in Clifton, Passaic County, NJ.",
  },
  {
    image: paverPatioHaskell,
    title: "Paver Patio & Fire Pit Installation",
    location: "Haskell, NJ",
    alt: "Before and after paver patio installation with fire pit and outdoor seating in Haskell, Passaic County, NJ, by Masonry Pro",
  },
  {
    image: outdoorKitchenKinnelon,
    title: "Outdoor Kitchen & Paver Patio",
    location: "Kinnelon, NJ",
    alt: "Luxury outdoor kitchen and paver patio installed at a home in Kinnelon, Morris County, NJ by Masonry Pro Construction.",
  },
  {
    image: paverPatioBloomingdale,
    title: "Paver Patio Installation",
    location: "Bloomingdale, NJ",
    alt: "Paver patio installation next to a wooden fence and deck in Bloomingdale, Passaic County, NJ by Masonry Pro Construction.",
  },
  {
    image: paverPatioStoneWallPompton,
    title: "Paver Patio with Stone Wall",
    location: "Pompton Lakes, NJ",
    alt: "Newly installed paver patio with a stone wall fire pit in Pompton Lakes, Passaic County, NJ, Masonry Pro Construction",
  },
  {
    image: retainingWallPompton,
    title: "Retaining Wall Installation",
    location: "Pompton Lakes, NJ",
    alt: "New retaining wall with steps and landscaping for a home in Pompton Lakes, Passaic County, NJ, Masonry Pro construction",
  },
  {
    image: stoneMasonryStepsFairLawn,
    title: "Stone Masonry Steps",
    location: "Fair Lawn, NJ",
    alt: "Newly installed stone masonry steps on a residential property in Fair Lawn, Bergen County, NJ by Masonry Pro construction.",
  },
  {
    image: patioClifton,
    title: "Patio Paver Installation",
    location: "Clifton, NJ",
    alt: "New patio paver installation on a residential property in Clifton, Passaic County, NJ, Masonry Pro construction.",
  },
  {
    image: patioParamus4,
    title: "Patio Paver Installation with Gazebo",
    location: "Paramus, NJ",
    alt: "New patio paver installation with a black gazebo and planted beds in Paramus, Bergen County, NJ.",
  },
  {
    image: masonyStepsWoodlandPark,
    title: "Masonry Steps Installation",
    location: "Woodland Park, NJ",
    alt: "New masonry steps installation with dark pavers in Woodland Park, Passaic County, NJ, Masonry Pro Construction",
  },
  {
    image: paverDrivewayTotowa,
    title: "Paver Driveway & Retaining Wall",
    location: "Totowa, NJ",
    alt: "New paver driveway and stone retaining wall at a home in Totowa, Passaic County, NJ, Masonry Pro Construction",
  },
  {
    image: patioLittleFalls,
    title: "Patio & Retaining Wall Installation",
    location: "Little Falls, NJ",
    alt: "Outdoor transformation with a new paver patio and retaining wall installation in Little Falls, Passaic County, NJ.",
  },
  {
    image: retainingWallMillburn,
    title: "Retaining Wall Installation",
    location: "Millburn, NJ",
    alt: "Retaining wall installation, before and after, at a residential home in Millburn, Essex County, NJ, Masonry Pro Construction",
  },
  {
    image: retainingWallShortHills,
    title: "Retaining Wall Replacement",
    location: "Short Hills, NJ",
    alt: "Retaining wall replacement showing before and after in Short Hills, Essex County, NJ, Masonry Pro Construction",
  },
  {
    image: retainingWallWestOrange,
    title: "Retaining Wall Replacement",
    location: "West Orange, NJ",
    alt: "New retaining wall replacement alongside a sidewalk in West Orange, Essex County, NJ, Masonry Pro Construction",
  },
  {
    image: paverPatioMontclairNew,
    title: "Paver Patio Installation",
    location: "Montclair, NJ",
    alt: "Before and after of a new paver patio replacing a wooden deck in Montclair, Essex County, NJ, Masonry Pro Construction",
  },
  {
    image: paverPatioPathwayHackensack,
    title: "Patio & Pathway Installation",
    location: "Hackensack, NJ",
    alt: "Outdoor patio and stepping stone pathway installation at a home in Hackensack, Bergen County, NJ, Masonry pro construction",
  },
  {
    image: paverPatioHackensack,
    title: "Paver Patio & Retaining Wall",
    location: "Hackensack, NJ",
    alt: "New paver patio installation with stone retaining walls at a residential property in Hackensack, Bergen County, NJ.",
  },
  {
    image: retainingWallHawthorne,
    title: "Retaining Wall Installation",
    location: "Hawthorne, NJ",
    alt: "Newly installed retaining wall with steps in a residential yard in Hawthorne, Passaic County, NJ.",
  },
  {
    image: paverPatioEssexFells,
    title: "Paver Patio Installation",
    location: "Essex Fells, NJ",
    alt: "Back of home with new paver patio and fresh topsoil installed in Essex Fells, Essex County, NJ.",
  },
  {
    image: masonryStepsMidlandPark,
    title: "Masonry Steps Installation",
    location: "Midland Park, NJ",
    alt: "New masonry steps with white railings lead to a home in Midland Park, Bergen County, NJ, Masonry Pro Construction",
  },
  {
    image: retainingWallTotowa2,
    title: "Retaining Wall Installation",
    location: "Totowa, NJ",
    alt: "Retaining wall with steps built into a sloped yard for a residential property in Totowa, Passaic County, NJ.",
  },
  {
    image: retainingWallPaterson,
    title: "Retaining Wall Replacement",
    location: "Paterson, NJ",
    alt: "New retaining wall replacement in Paterson, Passaic County, NJ, shown with before and after views, Masonry Pro Construction",
  },
  {
    image: retainingWallWayneNew,
    title: "Retaining Wall Installation",
    location: "Wayne, NJ",
    alt: "Retaining wall with steps built along a driveway in Wayne, Passaic County, NJ, Masonry Pro Construction.",
  },
  {
    image: retainingWallWayneBA,
    title: "Retaining Wall Installation",
    location: "Wayne, NJ",
    alt: "Before and after retaining wall installation on a steep hillside in Wayne, NJ, showing a sloped lawn transformed into tiered masonry retaining walls by Masonry Pro Construction.",
  },
];

export function GallerySection() {
  const plugin = useRef(
    Autoplay({ delay: 5000, stopOnInteraction: true, stopOnMouseEnter: true })
  );

  return (
    <section id="gallery" className="py-24 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            North New Jersey <span className="text-gradient-gold">Transformations</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See how we solve real structural and visual challenges for North Jersey homeowners.
          </p>
        </div>

        <div className="max-w-6xl mx-auto px-12">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            plugins={[plugin.current]}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {projects.map((project, index) => (
                <CarouselItem
                  key={index}
                  className="pl-4 basis-full md:basis-1/2 lg:basis-1/3"
                >
                  <div className="group relative overflow-hidden rounded-xl aspect-[3/5] bg-black/40 cursor-pointer">
                    <img
                      src={project.image}
                      alt={project.alt}
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                      width={400}
                      height={667}
                    />
                    
                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300" />
                    
                    {/* Content */}
                    <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                      <p className="text-secondary text-base font-medium">
                        {project.location}
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex" />
            <CarouselNext className="hidden md:flex" />
          </Carousel>
        </div>

        <div className="text-center mt-12">
          <Button variant="goldOutline" size="lg" asChild>
            <Link to="/gallery#paver-patios">View All Project Videos</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
